import axios from 'axios';

export function getAgeLevels(params = {}) {
  return axios.get('/api/v2/age_levels', { params });
}
